export default "__VITE_ASSET__763df073__"